import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import React, { useEffect, useState } from 'react';
import { styles } from './DimensionsImage.css';
interface DimensionsImageProps {
  src: string;
  width?: string;
  height?: string;
  depth?: string;
  weight?: string;
  title?: string;
}

const PLACEHOLDER_TEXT = '     -';

export const DimensionsImage = ({
  src,
  width = PLACEHOLDER_TEXT,
  height = PLACEHOLDER_TEXT,
  depth = PLACEHOLDER_TEXT,
  weight = PLACEHOLDER_TEXT,
  title,
}: DimensionsImageProps) => {
  const [svgContent, setSvgContent] = useState('');
  const [viewBox, setViewBox] = useState('0 0 508 557');
  const isMobile = useBreakpoint('lg', 'down');

  useEffect(() => {
    let shouldCancel = false;
    const fetchSvg = async () => {
      try {
        const response = await fetch(src);
        if (response.status !== 200) return null;
        const svg = await response.text();
        if (!shouldCancel) {
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(svg, 'image/svg+xml');
          const viewBoxValue = svgDoc.documentElement.getAttribute('viewBox') || '0 0 508 557';
          setViewBox(viewBoxValue);
          const textTags = svgDoc.documentElement.querySelectorAll('tspan');
          textTags.forEach(textElement => {
            if (!(title && textElement?.textContent?.includes(title))) {
              textElement.classList.add('dimension-image');
            }
          });

          const serializer = new XMLSerializer();
          const updatedSvg = serializer
            .serializeToString(svgDoc.documentElement)
            .replace(/{width}/g, width)
            .replace(/{height}/g, height)
            .replace(/{depth}/g, depth)
            .replace(/{weight}/g, weight);
          setSvgContent(updatedSvg);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchSvg();
    return () => {
      shouldCancel = true;
    };
  }, [src]);

  if (!svgContent) {
    return null;
  }
  return (
    <>
      <svg
        className={styles.svg}
        width={isMobile ? '80%' : '100%'}
        height="100%"
        viewBox={viewBox}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </>
  );
};
